__turbopack_context__.v({
  "busy": "TextInput-module__c-W5rq__busy",
  "hasSuffix": "TextInput-module__c-W5rq__hasSuffix",
  "input": "TextInput-module__c-W5rq__input",
  "input--error": "TextInput-module__c-W5rq__input--error",
  "inputContainer": "TextInput-module__c-W5rq__inputContainer",
  "inputLarge": "TextInput-module__c-W5rq__inputLarge",
});
